import React, { FC } from 'react'
import classNames from 'classnames'

import StylesModule from 'components/lv2/SpecList.module.scss'

import { SpecProps } from 'message/index.props'

export interface SpecListProps {
  specName: SpecProps
  specRoom: SpecProps
}
const lists = [
  {
    title: 'title',
    text: 'text',
  },
  {
    title: 'title',
    text: 'text',
  },
]

const SpecList: FC<SpecListProps> = ({ specName, specRoom }) => {
  return (
    <div className={classNames(StylesModule.specList)}>
      <dl>
        <dt>
          <div>{specName.room_size}</div>
        </dt>
        <dd>
          <div>{specRoom.room_size}</div>
        </dd>

        <dt>
          <div>{specName.capacity}</div>
        </dt>
        <dd>
          <div>{specRoom.capacity}</div>
        </dd>

        <dt>
          <div>{specName.bed_type}</div>
        </dt>
        <dd>
          <div
            dangerouslySetInnerHTML={{
              __html: specRoom.bed_type,
            }}
          />
        </dd>

        <dt>
          <div>{specName.bed_size}</div>
        </dt>
        <dd>
          <div
            dangerouslySetInnerHTML={{
              __html: specRoom.bed_size,
            }}
          />
        </dd>

        <dt>
          <div>{specName.facilities}</div>
        </dt>
        <dd>
          <div
            dangerouslySetInnerHTML={{
              __html: specRoom.facilities,
            }}
          />
        </dd>

        <dt>
          <div>{specName.amenity}</div>
        </dt>
        <dd>
          <div
            dangerouslySetInnerHTML={{
              __html: specRoom.amenity,
            }}
          />
        </dd>
      </dl>
    </div>
  )
}

export default SpecList
